import About from '@/components/About';
import Layout from '@/components/Layout';
import API from '../api';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import {getServerSidePaths} from "@/pages/contacts/[slug]";

// Заглушка для переводов
const translate = s => s;

const AboutPage = ({ data }) => {
  return <About data={data} />;
};

const breadcrumbs = [
  { title: translate('Главная'), route: '/' },
  { title: translate('О компании'), route: '/about' },
];

AboutPage.getLayout = (page, t) => (
  <Layout page={page.props} breadcrumbs={breadcrumbs} title={t('О компании — UNIFROST')}>
    {page}
  </Layout>
);

export async function getServerSideProps(context) {
  const props = { data: { team: [], documents: [] } };

  try {
    const res = await API.get(`/v1/api/pages/about/`, {
      headers: { 'Accept-Language': context.locale },
    });

    if (res.status === 200) {
      if (res.data) props.data = res.data;
    }
  } catch (error) {}

  try {
    const resTeam = await API.get(`/v1/api/teams/`, {
      headers: { 'Accept-Language': context.locale },
    });

    if (resTeam.status === 200 && Array.isArray(resTeam.data)) {
      if (resTeam.data) props.data.team = resTeam.data;
    }
  } catch (error) {}

  try {
    const resDocs = await API.get(`/v1/api/documents/`, {
      headers: { 'Accept-Language': context.locale },
    });

    if (resDocs.status === 200 && Array.isArray(resDocs.data)) {
      if (resDocs.data) props.data.documents = resDocs.data;
    }
  } catch (error) {}

  return {
    props: {
      ...props,
      ...(await serverSideTranslations(context.locale, ['common', 'menu'])),
    },
    // revalidate: 60,
  };
}

export default AboutPage;
